import router from "../../router";

export const changes = function (payload, item) {
    const id = payload.id;

    const fileProps = Object.keys(payload).filter(prop => {
        return prop.endsWith('_file') || prop === 'file';
    })

    const fileLists = Object.keys(payload).filter(prop => {
        return payload[prop] instanceof FileList
    })

    const files = {}

    for (let prop of fileProps) {
        files[prop] = payload[prop]
        delete payload[prop]
    }

    fileLists.forEach(list => {
        if (payload[list].length > 1) {
            files[list] = [...payload[list]];
        }
        if (payload[list].length === 1) {
            files[list] = payload[list][0]
        }
    })

    let data = JSON.parse(JSON.stringify(payload));

    delete data.id;

    for (let prop in payload) {
        if (
            item[prop] === payload[prop]
            || (
                Array.isArray(payload[prop])
                && Array.isArray(item[prop])
                && JSON.stringify(item[prop]) === JSON.stringify(payload[prop])
            )
            || (
                typeof item[prop] === 'object' && typeof payload[prop] === 'object'
                && ((!item[prop] && !payload[prop]) || JSON.stringify(item[prop]) === JSON.stringify(payload[prop]))
            )
        ) {
            delete data[prop];
        }
    }

    let base = {}

    if (payload?.query) {
        base = JSON.parse(JSON.stringify(payload.query));
    }

    data = Object.assign(base || {}, data, files);

    return {
        id: id,
        data: data
    }
}
const flattenErrors = function (errors) {
    const flat = {};

    Object.keys(errors || {}).forEach(key => {
        const value = errors[key];

        if (Array.isArray(value) && value.every(item => typeof item === 'string')) {
            flat[key] = value;
            return;
        }

        if (value && typeof value === 'object') {
            Object.keys(value).forEach(inner => {
                const nested = value[inner];

                flat[key + '.' + inner] = Array.isArray(nested) ? nested : [String(nested)];
            });
            return;
        }

        flat[key] = [String(value)];
    });

    return flat;
}

export const handleError = function (e, commit) {
    const data = (e && e.response && e.response.data) || {};

    if (data.messages) {
        commit('SET_ERRORS', flattenErrors(data.messages));
    } else if (data.errors) {
        commit('SET_ERRORS', flattenErrors(data.errors));
    }

    const message = data.message || data.detail || data.title || ''

    if (message) {
        commit('app/ADD_ALERT', {
            message: message,
            style: 'error',
            icon: 'error',
            countdown: 3000
        }, { root: true })
    }
    loading(commit, false)
    switch (e.response?.status) {
        case 401:
            router.push({name: 'login'});
            break;
        case 302:
            router.push(e.response.data.redirect);
            break;
        // case 403:
            // Todo create 403 page
        default:
            // throw e;
    }

    return false;
}

export const loading = function (commit, loading = true) {
    commit('app/SET_LOADING', loading, {root: true})
    commit('SET_LOADING', loading)
}

export const customLoading = function (commit, mutation, loading = true) {
    commit(mutation, loading);
}

export const alert = function (commit, message, style = 'success', icon = 'success', countdown = 3000) {
    commit('app/ADD_ALERT', {
        message: message,
        style: style,
        icon: icon,
        countdown: countdown
    }, { root: true });
}

export function destroyLocal(key) {
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
}

export function storeLocal(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value));
    window.sessionStorage.setItem(key, JSON.stringify(value));
}

export function getLocal(key) {
    const item = window.sessionStorage.getItem(key) || window.localStorage.getItem(key)

    if (item !== null && item !== 'undefined') {
        return JSON.parse(item)
    }

    return null
}
